export const CLINICAL_CRM_TABS = Object.freeze({
  PIPELINE: 'pipeline',
  ANALYTICS: 'analytics',
  EXPORTS: 'exports',
});

export const clinicalCrmTabQuery = tab => ({ tab });

export const resolveClinicalCrmTab = (requestedTab, availableTabs) => {
  const normalizedTab = String(requestedTab || CLINICAL_CRM_TABS.PIPELINE);
  return availableTabs.includes(normalizedTab)
    ? normalizedTab
    : CLINICAL_CRM_TABS.PIPELINE;
};

export const ensureClinicalCrmTabQuery = to => {
  if (to.query?.tab) return undefined;

  return {
    name: 'clinical_crm_index',
    params: to.params,
    query: {
      ...(to.query || {}),
      ...clinicalCrmTabQuery(CLINICAL_CRM_TABS.PIPELINE),
    },
    replace: true,
  };
};
